// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_format from "../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Row$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as GeoRegionHook from "../../../../../library/data-source/geo-region/repo/GeoRegionHook.bs.js";
import * as CountryContext from "../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as Button$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/Button.bs.js";
import * as Column$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Column.bs.js";
import * as CreateCustomerDM from "../../data-machine/CreateCustomerDM.bs.js";
import * as WorkSpaceContext from "../../../../../library/work-space/WorkSpaceContext.bs.js";
import * as CraeteCustomerForm from "./CraeteCustomerForm.bs.js";
import * as FormInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.bs.js";
import * as FormHelper$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/FormHelper.bs.js";
import * as FormTextInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormTextInput.bs.js";
import * as CircularLoader$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/loaders/CircularLoader.bs.js";
import * as FormSelectInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormSelectInput.bs.js";
import * as SelectComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/drop-downs/SelectComponent.bs.js";
import * as ToastSnackbarHook$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/hooks/toast-notification/ToastSnackbarHook.bs.js";
import * as ErrorDisplayComponent$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/error/ErrorDisplayComponent.bs.js";

function CraeteCustomerFormCmp(Props) {
  var phone_number = Props.phone_number;
  var match = ToastSnackbarHook$Catalyst.useSnackbar(5000, undefined, undefined);
  var openSnackbar = match[1];
  var match$1 = CountryContext.useContext(undefined);
  var country = match$1.country;
  var workspaceDispatch = WorkSpaceContext.useWorkSpace(undefined);
  var geoRegions = GeoRegionHook.useGeoRegions(country);
  var form = CraeteCustomerForm.Form.useForm({
        firstName: "",
        lastName: "",
        city: FormSelectInput$Catalyst.SelectUtils.getSelectComponentItem(undefined, (function (a) {
                return a;
              })),
        useOfPorter: FormSelectInput$Catalyst.SelectUtils.getSelectComponentItem(undefined, (function (a) {
                return a;
              }))
      }, {
        country: country
      }, (function (output, param) {
          var customer_first_name = output.firstName;
          var customer_last_name = output.lastName;
          var customer_geo_region_id = Caml_format.caml_int_of_string(output.city);
          var customer_frequency = output.useOfPorter;
          var customer = {
            mobile: phone_number,
            first_name: customer_first_name,
            last_name: customer_last_name,
            geo_region_id: customer_geo_region_id,
            frequency: customer_frequency
          };
          return CreateCustomerDM.createdCustomer(customer, country, (function (data) {
                        Curry._1(openSnackbar, {
                              TAG: /* Success */0,
                              _0: "Custerm created!"
                            });
                        return Curry._1(workspaceDispatch.replaceTab, {
                                    TAG: /* CustomerProfileNew */2,
                                    _0: phone_number,
                                    _1: data.customer_id
                                  });
                      }), (function (param) {
                        return Curry._1(openSnackbar, {
                                    TAG: /* Error */1,
                                    _0: "Something Went wrong!"
                                  });
                      }));
        }));
  var useOfPorterOptions = {
    hd: {
      key: "1",
      value: "personal",
      text: "Personal"
    },
    tl: {
      hd: {
        key: "2",
        value: "business",
        text: "Business"
      },
      tl: /* [] */0
    }
  };
  var tmp;
  switch (geoRegions.TAG | 0) {
    case /* Loading */0 :
        tmp = React.createElement(CircularLoader$Catalyst.make, {});
        break;
    case /* Live */1 :
        var geoRegionOptions = List.map((function (e) {
                return {
                        key: String(e.id),
                        value: String(e.id),
                        text: e.name
                      };
              }), geoRegions._0);
        tmp = React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "form-container"
                }, React.createElement(Row$Catalyst.make, {
                      children: React.createElement(Column$Catalyst.make, {
                            children: React.createElement(FormTextInput$Catalyst.make, {
                                  input_props: FormInput$Catalyst.make_props("Customer Phone Number", undefined, true, undefined, undefined, undefined, undefined, undefined, {
                                        TAG: /* Ok */0,
                                        _0: phone_number
                                      }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                  textinput_props: {
                                    value: phone_number
                                  }
                                }),
                            className: ""
                          })
                    }), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement(Column$Catalyst.make, {
                          children: React.createElement(FormTextInput$Catalyst.make, {
                                input_props: FormInput$Catalyst.make_props("Enter First Name", (function ($$event) {
                                        return Curry._2(form.updateFirstName, (function (input, value) {
                                                      return {
                                                              firstName: value,
                                                              lastName: input.lastName,
                                                              city: input.city,
                                                              useOfPorter: input.useOfPorter
                                                            };
                                                    }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                      }), undefined, undefined, "Enter First Name", undefined, undefined, undefined, form.firstNameResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                textinput_props: {
                                  value: form.input.firstName
                                }
                              }),
                          className: "w-50"
                        }), React.createElement(Column$Catalyst.make, {
                          children: React.createElement(FormTextInput$Catalyst.make, {
                                input_props: FormInput$Catalyst.make_props("Enter Last Name", (function ($$event) {
                                        return Curry._2(form.updateLastName, (function (input, value) {
                                                      return {
                                                              firstName: input.firstName,
                                                              lastName: value,
                                                              city: input.city,
                                                              useOfPorter: input.useOfPorter
                                                            };
                                                    }), FormHelper$Catalyst.TargetEventWrapper.value($$event));
                                      }), undefined, undefined, "Enter First Name", undefined, undefined, undefined, form.lastNameResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                textinput_props: {
                                  value: form.input.lastName
                                }
                              }),
                          className: "w-50"
                        })), React.createElement(Row$Catalyst.make, {
                      children: null
                    }, React.createElement(Column$Catalyst.make, {
                          children: React.createElement(FormSelectInput$Catalyst.make, {
                                input_props: FormInput$Catalyst.make_props("Region", (function ($$event) {
                                        return Curry._2(form.updateCity, (function (input, value) {
                                                      return {
                                                              firstName: input.firstName,
                                                              lastName: input.lastName,
                                                              city: value,
                                                              useOfPorter: input.useOfPorter
                                                            };
                                                    }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), geoRegionOptions));
                                      }), undefined, undefined, undefined, undefined, undefined, undefined, form.cityResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                select_props: {
                                  value: form.input.city,
                                  items: geoRegionOptions,
                                  isNoneRequired: true
                                }
                              }),
                          className: "w-50"
                        }), React.createElement(Column$Catalyst.make, {
                          children: React.createElement(FormSelectInput$Catalyst.make, {
                                input_props: FormInput$Catalyst.make_props("Use OF Porter?", (function ($$event) {
                                        return Curry._2(form.updateUseOfPorter, (function (input, value) {
                                                      return {
                                                              firstName: input.firstName,
                                                              lastName: input.lastName,
                                                              city: input.city,
                                                              useOfPorter: value
                                                            };
                                                    }), SelectComponent$Catalyst.getSelectedItem(FormHelper$Catalyst.TargetEventWrapper.value($$event), useOfPorterOptions));
                                      }), undefined, undefined, undefined, undefined, undefined, undefined, form.useOfPorterResult, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
                                select_props: {
                                  value: form.input.useOfPorter,
                                  items: useOfPorterOptions,
                                  isNoneRequired: true
                                }
                              }),
                          className: "w-50"
                        })), React.createElement("div", {
                      className: "footer"
                    }, React.createElement(Button$Catalyst.make, {
                          text: "Submit",
                          cb: (function (_event) {
                              return Curry._1(form.submit, undefined);
                            }),
                          className: "btn-primary disabled"
                        }))));
        break;
    case /* Error */2 :
        tmp = React.createElement(ErrorDisplayComponent$Catalyst.make, {
              error: geoRegions._0
            });
        break;
    
  }
  return React.createElement("div", {
              className: "customer-info-form-conatainer"
            }, React.createElement("div", {
                  className: "header"
                }, React.createElement("p", undefined, "Customer Information"), React.createElement("div", {
                      className: "header-actions"
                    })), tmp, match[0]);
}

var make = CraeteCustomerFormCmp;

export {
  make ,
  
}
/* react Not a pure module */
